import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { UPDATE_CHALLENGE_SIMPLE_DETAILS_MUTATION } from '../graphql/mutations'
import { transformToUpdateChallengeSimpleDetailsArgs } from '../graphql/transformers'
import { UPDATE_CHALLENGE_SIMPLE_DETAILS } from '../redux/action-types'

const useUpdateChallengeSimpleDetailsMutation = () => {
  const dispatch = useDispatch()

  const { isSimpleDetailsLoading, simpleDetailsError } = useSelector(
    store => store.challenges.challenge,
  )

  const mutate = useCallback(
    (id, data) =>
      apolloService.mutate(
        UPDATE_CHALLENGE_SIMPLE_DETAILS_MUTATION,
        { id, data: transformToUpdateChallengeSimpleDetailsArgs(data) },
        dispatch,
        UPDATE_CHALLENGE_SIMPLE_DETAILS,
      ),
    [dispatch],
  )

  return [
    mutate,
    { isLoading: isSimpleDetailsLoading, error: simpleDetailsError },
  ]
}

export default useUpdateChallengeSimpleDetailsMutation
